import React from "react";
import PropTypes from "prop-types";
import { Document, Page, View, Link, Text, Image, Font } from "@react-pdf/renderer";
import LogoLinewize from "./LogoLinewize";
import LogoSmoothwallGreen from "./LogoSmoothwallGreen";
import styles from "./PDFSnapshotStyles";

Font.register({
	family: "Roboto",
	fonts: [
		{ src: "https://fonts.gstatic.com/s/roboto/v29/KFOmCnqEu92Fr1Me5Q.ttf" },
		{
			src: "https://fonts.gstatic.com/s/roboto/v29/KFOlCnqEu92Fr1MmWUlvAw.ttf",
			fontWeight: "bold",
		},
	],
});

const DeviceDetailsItem = ({ title, detail }) => (
	<View style={styles.deviceDetailItem}>
		<Text style={styles.deviceDetailItemText}>
			<Text style={{ fontWeight: "bold" }}>{title}: </Text>
			{detail}
		</Text>
	</View>
);
DeviceDetailsItem.propTypes = {
	title: PropTypes.string.isRequired,
	detail: PropTypes.string.isRequired,
};

const LiveViewReport = (props) => (
	<Document title={props.filename} author="Classwize" creator="Classwize">
		<Page orientation="landscape" style={styles.main} wrap={false}>
			<View style={styles.header}>
				<View>
					<Text style={styles.title}>
						{props.studentName} ({props.studentUsername}) | {props.deviceName}
					</Text>
					<Link src={props.url} style={styles.linkStyle}>
						{props.url}
					</Link>
				</View>
				{
					<View style={props.smoothwall ? styles.headerLogoSmoothwall : styles.headerLogo}>
						{props.smoothwall ? <LogoSmoothwallGreen /> : <LogoLinewize />}
					</View>
				}
			</View>
			<View style={styles.imageContainer}>
				<Link src={props.url}>
					<Image style={styles.screenshot} src={props.image} />
				</Link>
			</View>
			<View style={styles.footer}>
				<View style={styles.deviceDetails}>
					<DeviceDetailsItem title={"Screenshot taken"} detail={props.timestamp} />
					{props.platform && <DeviceDetailsItem title={"Device"} detail={props.platform} />}
					{props.teacher && <DeviceDetailsItem title={"Teacher"} detail={props.teacher} />}
					{props.class && <DeviceDetailsItem title={"Class"} detail={props.class} />}
					{props.mac && <DeviceDetailsItem title={"MAC address"} detail={props.mac} />}
				</View>
				<View style={styles.footerRight}>
					<Text style={styles.timestamp}>{props.timestamp}</Text>
					<Text style={styles.pageNum}>Page 1/1</Text>
				</View>
			</View>
		</Page>
	</Document>
);

LiveViewReport.propTypes = {
	filename: PropTypes.string,
	image: PropTypes.string.isRequired,
	url: PropTypes.string,
	studentName: PropTypes.string.isRequired,
	studentUsername: PropTypes.string.isRequired,
	deviceName: PropTypes.string.isRequired,
	timestamp: PropTypes.string.isRequired,
	mac: PropTypes.string,
	class: PropTypes.string,
	teacher: PropTypes.string,
	platform: PropTypes.string,
	smoothwall: PropTypes.bool,
};

export default LiveViewReport;
